<template>
	<div class="page">

		<scroll-to :links="scrollTo"></scroll-to>


		<div class="page-content-wrap">
			

			<div class="content-place">

				<div class="row">
					<errors></errors>
				</div>

				<div class="row">
					<h3 id="s1" class="title-steps">Снимки</h3>
					<div class="col-lg-12 section-work">
						<sortableImages @exportImages="exportImages"  :images="www.images"></sortableImages>
					</div>
				</div>

				<div class="row">
					<h3 id="s2" class="title-steps">Мета дани</h3>
					<div class="col-lg-12 section-work">
						<forms v-if="this.openForms" @exportMeta="exportMeta" :formElements="formElements"></forms>
					</div>
				</div>

				<div class="row">
					<h3 id="s3" class="title-steps">Описание</h3>
					<div class="col-lg-12 section-work">
						<editor @exportContent="exportContent" :contentt="www.description"></editor>	
					</div>
				</div>

				<div class="row">
					<h3 id="s3" class="title-steps">Опции</h3>
					<div class="col-lg-12 section-work">
						<form-list :limit="15" :filters="www.options" :where="'soft/option/search'" @exportList="exportOption"></form-list>
					</div>
				</div>

				<div class="row">
					<h3 id="s2" class="title-steps">Значение за опции</h3>
					<div class="col-lg-12 section-work">
						<forms v-if="this.stateFormptions" @exportMeta="exportFormOptions" :formElements="formOptions"></forms>
						<div v-else>
							<p>Избери опции</p>
						</div>
					</div>
				</div>

				<div class="row">
					<h3 id="s4" class="title-steps">Taxile care</h3> <div class="col-lg-12 section-work">
						<form-list :limit="15" :filters="www.textileCares" :where="'soft/textile-care/search'" @exportList="exporttextileCares"></form-list>
					</div>
				</div>

				<div class="row">
					<h3 id="s4" class="title-steps">Категория</h3>
					<div class="col-lg-12 section-work">
						<form-list :limit="1" :filters="www.group" :where="'soft/material/group/search'" @exportList="exportMaterialGroup"></form-list>
					</div>
				</div>
				
			</div>

			
		</div>
		
		<bottom-menu :www="www"></bottom-menu>
		<modal-create-folder v-if="modalCreateFolder"></modal-create-folder>

	</div>
</template>
<script>
	
	import ModalCreateFolder from "../../app_modules/ModalCreateFolder";


	import ScrollTo from '../../../components/layouts/ScrollTo'
	import Errors from '../../../components/app_modules/Errors'
	import BottomMenu from '../../../components/app_modules/BottomMenu'
	import FormList from '../../../components/app_modules/FormList'
	
	import SortableImages from '../../../components/app_modules/SortableImages'
	import SortableCategory from '../../../components/app_modules/SortableCategory'

	import SortableProducts from '../../../components/app_modules/SortableProducts.vue'


	import Forms from '../../../components/app_modules/Forms'
	import Editor from '../../../components/app_modules/Editor'

	import axios from 'axios'

	export default {
		name: 'soft-material-create',

		
		data() {
			return {
				productPage: true,
				modalCreateFolder: false,
				openForms:false,
				stateFormptions: false,

				www: {
					link_send: this.$store.getters.getDomainName+'soft/material',
					method: 'post',
					redirect: 'soft-material',
					parent_id:0,
					title: '',
					status: 'true',
					poss: 0,
					images: [],
					dataOptions:[],
					options:[],
					group: [],
					textileCares: [],

					// category: [],
					description: ``,

				},
				formElements: [
				{
					id: 0,
					type: 'input',
					name: 'Title',
					placeholder: 'title for product H1',
					model: '',
					readonly: true
				},
				{
					id: 1,
					type: 'input',
					name: 'poss',
					placeholder: 'poss',
					model: '',
					readonly: true
				},
				{
					id: 2,
					type: 'input',
					name: 'code',
					placeholder: 'code',
					model: '',
					readonly: true
				},
				{
					id: 3,
					type: 'select',
					name: 'type',
					model: '',

					options: [
					{
						id: 0,
						value: 'Кожа',
						text: 'Кожа',
					},
					{
						id: 1,
						value: 'Еко кожа',
						text: 'Еко кожа',
					},
					{
						id: 2,
						value: 'Текстил',
						text: 'Текстил',
					},
					],
				},
				
				{
					id: 4,
					type: 'status',
					name: 'status',

					model: true,
				},
				],

				formOptions: [{},],


				scrollTo: [
				{
					id: 1,
					name: ' Лого',
					href: '#s1',
				},
				{
					id: 2,
					name: 'Мета дани',
					href: '#s2',
				},
				{
					id: 3,
					name: 'Описание',
					href: '#s3',
				},

				]
			}
		},
		mounted() {

			if(this.$route.params.id) {
				this.www.parent_id = this.$route.params.id
			}
		},
		methods: {

			exportContent(data) {
				this.www.description = data
			},
			exportMaterialGroup(data) {
				this.www.group = data
			},
			exportMeta(data) {
				console.log(data)
				this.www.title = data[0].model
				this.www.poss = data[1].model
				this.www.code = data[2].model
				this.www.type = data[3].model
				this.www.status = data[4].model
			},
			exportFormOptions(data) {
				this.generateData('dataOptions', data)
			},
			exportOption(data) {
				data = data.reverse()

				this.formOptions.push({ 

					id: data[0].id,
					ids: data[0].id,
					type: 'input',
					name: data[0].title,
					placeholder: 'цена за ' + data[0].title,
					model: data[0].value,
					readonly: true,
					selected: true,
				})
				this.stateFormptions = true

			},
			exporttextileCares(data) {
				this.www.textileCares = data
			},

			exportBrands(data) {
				this.www.brand = data
			},
			exportImages(data) {
				this.www.images = data
			},

			generateForm(nameObject, data) {

					if(nameObject == 'formOptions') {
						this.formOptions = []
					} 
				

					var formData = [];

					for (var i = data.length - 1; i >= 0; i--) {

						if(data[i].title != '') {

							if(!data[i].value) {
								data[i].value = '' 
							}

							formData.push({ 

								id: data[i].id,
								ids: data[i].id,
								type: 'input',
								name: data[i].title,
								placeholder: 'цена за ' + data[i].title,
								model: data[i].value,
								readonly: true,
								selected: true,
							})
						}
					}

				if(nameObject == 'formOptions') {
					this.formOptions = formData
					this.stateFormptions = true

				} 
			

			},

			generateData(nameObject, form) {
		

				
				if(nameObject == 'dataMaterials') {
					this.www.dataMaterials = []
				}
				if(nameObject == 'dataOptions') {
					this.dataOptions = []
				}

				var data = [];

				for (var i = form.length - 1; i >= 0; i--) {



						data.push({ 

							id: form[i].id,
							id: form[i].ids,
							title: form[i].name,
							value: form[i].model,
						})
				}
	
				if(nameObject == 'dataOptions') {
					this.www.dataOptions = data
					
				}
				if(nameObject == 'dataMaterials') {
					this.www.dataMaterials = data

					console.log(this.dataMaterials)
					console.log(this.dataMaterials)
					console.log(this.dataMaterials)
				}


			},
			
		},
		created() {
			eventBus.$on('closeModalCreateFolder', data => {
				this.modalCreateFolder = data
			})
			

			if(this.$route.name == 'soft-material-edit') {

				axios.get(this.$store.getters.getDomainName+'soft/material/'+this.$route.params.id+'/edit')

				.then(response => {
					this.www.title = response.data['title']
					this.www.poss = response.data['poss']
					this.www.type = response.data['type']
					this.www.code = response.data['code']
					this.www.status = response.data['status']
					this.www.group = response.data['group']
					this.www.textileCares = response.data['textileCares']


					if(response.data['soft_options'].length > 0) {
						this.generateForm('formOptions', response.data['soft_options'])
					this.www.dataOptions = response.data['soft_options']
					this.www.options = response.data['soft_options']
					}

					// send active category

					var images =  response.data['images'].split(";")
					images = images.reverse()

					for (var i = images.length - 1; i >= 0; i--) {
						if(images[i] != '') {
							this.www.images.push({ 
								icon: images[i],
								id: i,
							})
						}
					}

					this.www.description = response.data['description']
					this.www.brand = response.data['brand'] 
					this.www.parent_id = response.data['parent_id'] 

					this.formElements[0].model = response.data['title']
					this.formElements[1].model = response.data['poss']
					this.formElements[2].model = response.data['code']
					this.formElements[3].model = response.data['type']


					response.data['status'] == 0 ? this.formElements[4].model = false : this.formElements[4].model = true


					if(response.data['status'] == 0) {
						this.formElements[4].model = false
					} else {
						this.formElements[4].model = true
					}

					this.www.link_send = this.$store.getters.getDomainName+'soft/material/'+this.$route.params.id
					this.www.method = 'patch'

					eventBus.$emit('sendLinkAndMethod', this.www)

					this.openForms = true
					return


				})
				.catch(error => {
					// if(error.response.status == 404) {
					// 	this.$router.push({ name: '404' })
					// }
				})

				
			} else {
				this.openForms = true
			}
		},
		beforeDestroy() {
			eventBus.$off('closeModalCreateFolder')
		},
		components: {
			ModalCreateFolder,
			Forms,
			ScrollTo,
			Editor,
			//SortableCategory,
			Errors,
			BottomMenu,
			SortableImages,
			SortableCategory,
			SortableProducts,
			FormList
		},

	}
</script>

<style scoped src="../../../assets/css/page-data.css"></style>


// WEBPACK FOOTER //
// src/components/soft/material/data.vue